import { createContext, use } from "react";
import { ParameterConflict } from "src/store/api/generatedApi";

export interface DefaultParameterTabsActions {
  hasChanges: boolean;
  saveAvailability?: "ready" | "blocked";
  isChecking: boolean;
  isSaving: boolean;
  conflicts: ParameterConflict[];
  onSave: () => Promise<void>;
  onDiscard: () => void;
}

interface DefaultParametersContextType {
  hasMaterialLimitChanges: boolean;
  setHasMaterialLimitChanges: (hasChanges: boolean) => void;
  setTabActions: (actions: DefaultParameterTabsActions | null) => void;
}

export const DefaultParametersContext =
  createContext<DefaultParametersContextType | null>(null);

export const useDefaultParametersContext = (): DefaultParametersContextType => {
  const context = use(DefaultParametersContext);
  if (context === null) {
    throw new Error(
      "useDefaultParametersContext must be used within a DefaultParametersContext.Provider"
    );
  }
  return context;
};
